import { useState, useEffect } from 'react';
import clsx from 'clsx';

/**
 *   @deprecated
 *
 *   - scrollable: since only part of the drawer content is scrollable
 *   - extraClassNames: allows the user of Drawer component to inject css class for styling
 */
const Drawer = ({
  testid,
  children,
  visible,
  close,
  onVisible,
  closeText = 'CANCEL',
  scrollable = true,
  extraClassNames = {},
}) => {
  const [currentlyVisible, setVisible] = useState(false);

  let drawerClassNames = clsx('drawer', {
    visible,
    hide: typeof visible === 'boolean' && !visible,
    ...extraClassNames,
  });

  return (
    <div
      data-visible-state={visible === true ? 'visible' : 'hidden'}
      data-testid={testid}
      className={drawerClassNames}
    >
      <div
        className={`drawer-content ${scrollable ? 'scrollable-container' : ''}`}
      >
        {children}

        {closeText && (
          <div className="btn-container">
            <button className="hr-btn-hol" onClick={close}>
              {closeText}
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default Drawer;
